document.addEventListener("DOMContentLoaded", function () {
    function initSliders() {
      document.querySelectorAll(".shop-the-look-2__block").forEach((block, index) => {
        const slider = block.querySelector(".js-slider");
        if (slider) {
          slider.classList.add(`swiper-instance-${index}`);
          
          new Swiper(`.swiper-instance-${index}`, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            pagination: {
              el: `.swiper-pagination-${index}`,
              clickable: true,
              bulletClass: "pulse button-reset js-btn btn",
              renderBullet: function (bulletIndex, className) {
                return `<span class="${className} bullet-${bulletIndex + 1}"></span>`;
              }
            },
            navigation: {
              nextEl: `.swiper-button-next-${index}`,
              prevEl: `.swiper-button-prev-${index}`,
            },
            scrollbar: {
              el: `.shop-the-look-2__scrollbar-${index}`,
              draggable: true,
            },
          });
        }
      });
    }
  
    function setupLookSwitcher() {
      const lookItems = document.querySelectorAll('.shop-the-look-2__group-item-look');
      
      lookItems.forEach(item => {
        item.addEventListener('click', function() {
          const targetGroup = this.dataset.group;
          
          document.querySelectorAll('.shop-the-look-2__block').forEach(block => {
            block.style.display = block.dataset.group === targetGroup ? 'block' : 'none';
          });
        });
      });
  
      if (lookItems.length > 0) {
        lookItems[0].click();
      }
    }
  
    function setupDrawer() {
      document.querySelectorAll('.shop-the-look-2__cta-drawer').forEach(button => {
        button.addEventListener('click', function() {
          const drawer = this.closest('.shop-the-look-2__block').querySelector('.shop-the-look-2__drawer');
          if (drawer) {
            drawer.style.display = 'block';
            document.body.style.overflow = 'hidden';
          }
        });
      });
  
      document.querySelectorAll('.shop-the-look-2__drawer-close').forEach(button => {
        button.addEventListener('click', function() {
          const drawer = this.closest('.shop-the-look-2__drawer');
          if (drawer) {
            drawer.style.display = 'none';
            document.body.style.overflow = '';
          }
        });
      });
  
      document.querySelectorAll('.shop-the-look-2__drawer-overlay').forEach(overlay => {
        overlay.addEventListener('click', function() {
          const drawer = this.closest('.shop-the-look-2__drawer');
          if (drawer) {
            drawer.style.display = 'none';
            document.body.style.overflow = '';
          }
        });
      });
    }
  
    initSliders();
    setupLookSwitcher();
    setupDrawer();
  });